import React, { useState } from "react";
import { colors } from "../../../../../../themes/Colors";
import { BaseButtons } from "../../../../../common-components";

const OffenseItem = ({
  OffenseReference,
  Vehicle,
  IncidentDate,
  Description,
  User,
  onViewClick,
}) => {
  const [hover, setHover] = useState(false);
  return (
    <div
      style={{
        width: "100%",
        height: 50,
        backgroundColor: hover ? colors.greenLight : colors.white,
        display: "flex",
        alignItems: "center",
        fontWeight: "bold",
        fontSize: 10,
        color: hover ? colors.white : "#000000",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          flex: 0.2,
        }}
      >
        <div style={{ marginLeft: 10 }}>{OffenseReference}</div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          flex: 0.2,
        }}
      >
        {Vehicle}
      </div>
      {/* <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          flex: 0.2,
          borderStyle: "solid",
        }}
      >
        {IncidentDate}
      </div> */}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          flex: 0.2,
          overflow: "hidden",
        }}
      >
        {Description}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          flex: 0.2,
          overflow: "hidden",
        }}
      >
        {User}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flex: 0.1,
        }}
      >
        <BaseButtons
          label={"VIEW"}
          borderRadius={4}
          backgroundColor={colors.greenDark}
          width={100}
          height={30}
          onClick={onViewClick}
        />
      </div>
    </div>
  );
};

export default OffenseItem;
